import React from 'react';
import NavBar from "./NavBar";
import './Hero.css';
import logo from './assets/celtic-logo.jpeg';




function Hero() {


  return (
    <section className="hero">
       <NavBar currentPage="home" />

      <div className="hero-content">
        <img src={logo} alt="Logo" className="hero-logo" />

        <h1 className="hero-title">Celtic Plumbing & Heating</h1>
        <p className="hero-tagline">  
Reliable Service. Expert Craftsmanship.</p>
      </div>
    </section>
  );
}

export default Hero;
